/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Share_LinksInputs */

const en_gift_share_links = /** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share these links with your gift recipients`)
};

const es_gift_share_links = /** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte estos enlaces con los destinatarios`)
};

const fr_gift_share_links = /** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partagez ces liens avec les destinataires de vos cadeaux`)
};

const de_gift_share_links = /** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile diese Links mit deinen Geschenkempfängern`)
};

const id_gift_share_links = /** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan tautan ini dengan penerima hadiah Anda`)
};

/** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */
const ja_gift_share_links = en_gift_share_links;

/** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */
const zh_gift_share_links = en_gift_share_links;

/** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */
const ar_gift_share_links = en_gift_share_links;

/** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */
const it_gift_share_links = en_gift_share_links;

/** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */
const ru_gift_share_links = en_gift_share_links;

/** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */
const pt_gift_share_links = en_gift_share_links;

/** @type {(inputs: Gift_Share_LinksInputs) => LocalizedString} */
const ko_gift_share_links = en_gift_share_links;

/**
* | output |
* | --- |
* | "Share these links with your gift recipients" |
*
* @param {Gift_Share_LinksInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_share_links = /** @type {((inputs?: Gift_Share_LinksInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Share_LinksInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_share_links(inputs)
	if (locale === "es") return es_gift_share_links(inputs)
	if (locale === "fr") return fr_gift_share_links(inputs)
	if (locale === "de") return de_gift_share_links(inputs)
	if (locale === "ja") return ja_gift_share_links(inputs)
	if (locale === "zh") return zh_gift_share_links(inputs)
	if (locale === "ar") return ar_gift_share_links(inputs)
	if (locale === "id") return id_gift_share_links(inputs)
	if (locale === "it") return it_gift_share_links(inputs)
	if (locale === "ru") return ru_gift_share_links(inputs)
	if (locale === "pt") return pt_gift_share_links(inputs)
	return ko_gift_share_links(inputs)
});